import type { FaireProductEntity } from "../../entity_types/product";

export const p_5h5wacee57: FaireProductEntity = {
  token: "p_5h5wacee57",
  type: "product",
  name: "Viral Cheese Squishy Toy",
  brandToken: "b_bya786doke",
  brandName: "Love and Repeat",
  imageUrl:
    "https://cdn.faire.com/fastly/67766c02fcc3f9d4af070b390bd5980bff68128e8cacf5b0b04f43aecd65de4a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d2cc5120f089c29b38b92a6072f7348c4eda7361543737a8cde6f426b9bc729.jpeg",
    "https://cdn.faire.com/fastly/0dcce65d8c059b44c510dbaeaad05e0d5e4c64fc0dd6b3c3d12588d77d43b7b8.jpeg",
    "https://cdn.faire.com/fastly/e759be3d54d255d88c9544c2a980b446150b0414f6d3d0a5e365d7a44fbb99db.jpeg",
    "https://cdn.faire.com/fastly/8c18c43a51b78d14c585970e46eab07073e6005cfa2fceab47bdc6a09aa0f243.jpeg",
    "https://cdn.faire.com/fastly/7dea7a86a3f486fb69c6f761a391f3187ff10e3997d20d60382050fc9bd08aee.jpeg",
    "https://cdn.faire.com/fastly/264610dfd50c273d01784001191a5d0d9acf1ed9b8eb28275245fa2451da8e94.jpeg",
    "https://cdn.faire.com/fastly/fc351c533183b5a7d84f3fe34d4010c46552f05766eff863be31023dd01bb2a3.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Viral Cheese Squishy Toy\r\n\r\n-Cheese Squishy Slow Rising Squeeze Toy, Soft Squishy Fidget Toy, Stress Relief Sensory Novelty Fidget Squishy Toy Gift for Kids and Adults\r\nRealistic Cheese Design and Fun Squeeze\r\n\r\n",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:44.166Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
